import React from 'react';
import { useTranslation } from 'react-i18next';
import { PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';

import { DetailsItem, MainDetailsContainer } from './table-details-item.styles';
import { IApplicationSetting } from '../../../applications.interfaces';



const TableDetailsItem = ({ application }: { application: IApplicationSetting }) => {
  const { t } = useTranslation(['settings']);

  const { email, eAUTemplate, eAUTemplateRejected, eAUTemplateAccepted } = application;

  return (
    <div>
      <MainDetailsContainer>
        <DetailsItem>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{`${t(
            'settings:applications.labels.email'
          )}:`}</Typography>
          <Typography>{email || '-'}</Typography>
        </DetailsItem>
        <DetailsItem>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{`${t(
            'settings:applications.labels.eAUTemplate'
          )}:`}</Typography>
          <Typography>{eAUTemplate?.subject || '-'}</Typography>
        </DetailsItem>
        <DetailsItem>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{`${t(
            'settings:applications.labels.eAUTemplateAccepted'
          )}:`}</Typography>
          <Typography>{eAUTemplateAccepted?.subject || '-'}</Typography>
        </DetailsItem>
        <DetailsItem>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{`${t(
            'settings:applications.labels.eAUTemplateRejected'
          )}:`}</Typography>
          <Typography>{eAUTemplateRejected?.subject || '-'}</Typography>
        </DetailsItem>
      </MainDetailsContainer>
    </div>
  );
};

export default TableDetailsItem;
